import { render, staticRenderFns } from "./medicalVisitDetail.vue?vue&type=template&id=703f04df&scoped=true&"
import script from "./medicalVisitDetail.vue?vue&type=script&lang=js&"
export * from "./medicalVisitDetail.vue?vue&type=script&lang=js&"
import style0 from "./medicalVisitDetail.vue?vue&type=style&index=0&id=703f04df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703f04df",
  null
  
)

export default component.exports